export default __webpack_public_path__ + "static/media/avatarA4.373a78a8.png";